import { Status } from '@/models/Status';

export interface ProductList {
  id: string;
  code: string;
  name: string;
  description: string;
  externalCode?: string;
  supplierId: string;
  status: Status;
  createdAt: Date;
  updatedAt: Date;
}

export interface ProductListCreate {
  name: string;
  description: string;
  externalCode?: string;
  supplierId?: string;
  status: Status;
}

export interface ProductListUpdate {
  name: string;
  description: string;
  externalCode?: string;
  status: Status;
}

export interface ProductLists {
  items: ProductList[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export interface ProductListSkuIds {
  items: string[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export interface ProductListRetailerAssignment {
  retailerId: string;
  status: Status;
  createdAt: Date;
  updatedAt: Date;
}

export interface ProductListRetailerAssignments {
  items: ProductListRetailerAssignment[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export interface ProductListStoreAssignment {
  storeId: string;
  status: Status;
  createdAt: Date;
  updatedAt: Date;
}

export interface ProductListStoreAssignments {
  items: ProductListStoreAssignment[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export const EffectivePortfolioSource = {
  StoreAssignment: 'STORE_ASSIGNMENT',
  RetailerAssignment: 'RETAILER_ASSIGNMENT',
  Unrestricted: 'UNRESTRICTED',
  SupplierUnavailable: 'SUPPLIER_UNAVAILABLE',
  Unknown: 'UNKNOWN',
} as const;

export type EffectivePortfolioSource =
  (typeof EffectivePortfolioSource)[keyof typeof EffectivePortfolioSource];

export interface EffectivePortfolio {
  supplierId: string;
  retailerId: string;
  storeId: string;
  source: EffectivePortfolioSource;
  productListIds: string[];
}
